import { Component, OnInit , Input } from '@angular/core';
import { MasterFormComponent } from '../../form/master-form/master-form.component';
import { MasterBlogComponent } from '../master-blog/master-blog.component';

@Component({
  selector: 'app-header-blog',
  templateUrl: './header-blog.component.html',
})
export class HeaderBlogComponent extends MasterBlogComponent {
  @Input() label: string;
  @Input() breadcrumb: Array<any>;
  menu = this.fetchMenu()
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/blog/header-blog/header-blog.component.ts